import React, { useState } from 'react';
import { DatePicker, Button } from 'antd';
import moment from 'moment';

interface SingleMonthRangePickerProps {
    onApply?: (dates: [moment.Moment | null, moment.Moment | null]) => void;
    initialValue?: [moment.Moment | null, moment.Moment | null];
}

const quickRanges = [
    {
        label: 'Today',
        getRange: () => [moment().startOf('day'), moment().endOf('day')],
    },
    {
        label: 'Last 7 Days',
        getRange: () => [moment().subtract(6, 'days').startOf('day'), moment().endOf('day')],
    },
    {
        label: 'Last 30 Days',
        getRange: () => [moment().subtract(29, 'days').startOf('day'), moment().endOf('day')],
    },
    {
        label: 'This Month',
        getRange: () => [moment().startOf('month'), moment().endOf('month')],
    },
    {
        label: 'Last Month',
        getRange: () => [
            moment().subtract(1, 'month').startOf('month'),
            moment().subtract(1, 'month').endOf('month'),
        ],
    },
];

const SingleMonthRangePicker = ({ onApply, initialValue }: SingleMonthRangePickerProps) => {
    const [dates, setDates] = useState<[moment.Moment | null, moment.Moment | null]>(initialValue);

    const disabledDate = (current: any) => {
        return current && current > moment().endOf('day');
    };
    const handleStartDateChange = (date: moment.Moment | null) => {
        setDates([date, dates[1]]);
    };

    const handleEndDateChange = (date: moment.Moment | null) => {
        setDates([dates[0], date]);
    };

    const handleApply = () => {
        if (onApply) {
            onApply(dates);
        }
    };

    const handleQuickRange = (getRange: () => [moment.Moment, moment.Moment]) => {
        const range = getRange();
        setDates(range);
        if (onApply) {
            onApply(range);
        }
    };

    return (
        <div style={{
            display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'flex-start',
        }}
        >
            <div style={{
                display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 4,
            }}
            >
                {quickRanges.map((q) => (
                    <Button
                        key={q.label}
                        style={{
                            border: '1px solid #d9d9d9',
                            borderRadius: 15,
                            padding: '4px 8px',
                        }}
                        onClick={() => handleQuickRange(q.getRange)}
                    >
                        {q.label}
                    </Button>
                ))}
            </div>
            <div style={{ display: 'flex', gap: '8px', width: '100%' }}>
                <DatePicker
                    value={dates[0]}
                    onChange={handleStartDateChange}
                    placeholder="Start Date"
                    disabledDate={disabledDate}
                    style={{ flex: 1 }}
                />
                <DatePicker
                    value={dates[1]}
                    onChange={handleEndDateChange}
                    placeholder="End Date"
                    disabledDate={disabledDate}
                    style={{ flex: 1 }}
                />
            </div>
            <div style={{
                display: 'flex',
                gap: '8px',
                width: '100%',
                justifyContent: 'flex-end',
                marginTop: 12,
                alignItems: 'center',
            }}
            >
                <Button type="primary" onClick={handleApply} disabled={!dates[0] || !dates[1]}>
                    Apply
                </Button>
            </div>
        </div>
    );
};

export default SingleMonthRangePicker;
